










































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import Draggable from 'vuedraggable'

@Component({
	components: {
		Draggable,
	},
})
export default class Table extends Vue {
	protected selectedRow: number = -1
	protected selectedCol: number = -1
	@Prop() private headers!: object[]
	@Prop() private rows!: object[]
	@Prop({ default: false }) private draggable!: boolean
	private tableScroll = {
		scroll: false as boolean,
		left: false as boolean,
		right: false as boolean,
	}
	private timeout: any = null
	private timeoutId: number = NaN
	private timeoutIndex: string = ''

	// private mounted() {
	// 	this.tableScrollEvent()
	// }

	get isMobile() {
		return this.$store.getters.isMobile
	}

	private touchEditBG(id: number, index: string) {
		if (id === this.timeoutId && index === this.timeoutIndex) {
			return '#f4f5f7'
		}
		return ''
	}

	private reorderRows(event) {
		if (event.moved) {
			this.$emit('reorder', event.moved.oldIndex, event.moved.newIndex)
		}
	}

	private setTimeout(id: number, index: string, event: any) {
		if (event.touches && event.touches.length > 1) {
			return
		}
		this.timeoutId = id
		this.timeoutIndex = index
		this.timeout = setTimeout(() => {
			this.showEdit(id, index)
			this.timeoutId = NaN
			this.timeoutIndex = ''
		}, 500)
	}

	private clearTimeout() {
		clearTimeout(this.timeout)
		this.timeoutId = NaN
		this.timeoutIndex = ''
	}

	private clickEdit(id: number, index: string) {
		if (!this.isMobile) {
			this.showEdit(id, index)
		}
	}

	private tableScrollEvent() {
		// const table = this.$refs.table as HTMLTableElement
		// if (table.clientWidth === table.scrollWidth) {
		// 	this.tableScroll.scroll = false
		// 	return
		// }
		// this.tableScroll.scroll = true
		// table.scrollLeft === 0 ? this.tableScroll.left = false : this.tableScroll.left = true
		// table.scrollWidth - table.clientWidth <= table.scrollLeft ?
		// 	this.tableScroll.right = false : this.tableScroll.right = true
	}

	private editRow(id: number) {
		this.$emit('edit', id)
	}

	private deleteRow(id: number) {
		this.$emit('delete', id)
	}

	private showEdit(id: number, index: string) {
		this.$emit('edit-single', id, index)
	}
}
